import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

const SeasonalBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const dismissed = sessionStorage.getItem('seasonal_banner_dismissed');
    if (!dismissed) setVisible(true);
  }, []);

  const dismiss = () => {
    setVisible(false);
    sessionStorage.setItem('seasonal_banner_dismissed', '1');
  };

  if (!visible) return null;

  return (
    <div className="seasonal-banner">
      <div className="container d-flex align-items-center justify-content-center gap-2">
        <span>🎉 Weekend BBQ Special — Every Saturday from 6PM</span>
        <a href="/menu" style={{ color: '#1A1A1A', fontWeight: 700, textDecoration: 'underline', fontSize: '0.85rem' }}>
          Learn More
        </a>
      </div>
      <button className="banner-close" onClick={dismiss} aria-label="Dismiss banner">
        <X size={16} />
      </button>
    </div>
  );
};

export default SeasonalBanner;
